// ================= THE STRIP ACROSS THE TOP OF EVERY PAGE THAT IS NOT THE GAME =================
//
// WHY THIS EXISTS, reported by the user against the live build and all three symptoms are one gap:
// "I don't see how to actually buy cards with credits", "I don't see my credits reported at the top
// of the page", and "there's no way to get back to the main start screen once you go to the deck
// builder without just using the browser back button".
//
// index.html has a brand bar, and the account chip in it carries the balance — its comment even
// says "on every screen", which was true of the four screens INSIDE index.html and false the moment
// a second page existed. deck-builder.html and library.html had no bar, no balance, and no way out
// except the browser's back button. A player on the builder could not see what they had, could not
// reach the place to spend it, and could not get back to the game.
//
// ONE MODULE RATHER THAN TWO RENDERS, on the argument js/card-tile.js records for the same reason:
// the alternative is each page writing its own balance line, and the day the wording or the
// singular/plural rule changes, one of them silently keeps the old one. The LINKS stay in each
// page's markup — a page does not link to itself, and that is a fact about the page, not a runtime
// decision — but the number is written here, once.
//
// IT NEVER FETCHES. The pages already ask GET /api/store during boot and both hold the answer; this
// takes what they were given. A module that made its own request would put two round trips on every
// page and could disagree with the screen underneath it.
window.PageNav = (function () {
  'use strict';

  const el = () => document.getElementById('page-nav-credits');

  // `state` is a StoreClient answer (or anything with the same three fields).
  //
  // HIDDEN UNLESS THERE IS A SIGNED-IN ACCOUNT TO REPORT ON, which is the same rule the brand-bar
  // chip follows and it matters in the same direction: "0 credits" shown to somebody with no
  // account is not a balance, it is an invitation to wonder where their credits went. A build with
  // no backend, a `file://` copy and a signed-out visitor all get nothing here.
  function render(state) {
    const box = el();
    if (!box) return false;
    const on = !!(state && state.configured && state.signedIn);
    if (!on) { box.hidden = true; box.textContent = ''; return false; }
    const n = Number(state.balance) || 0;
    box.hidden = false;
    // Written as one element with the number bold inside it rather than as two spans with a gap,
    // because "12 credits" must never wrap between the figure and its unit.
    box.innerHTML = '<b>' + n + '</b> ' + (n === 1 ? 'credit' : 'credits');
    // The balance is the one thing in the bar that can change its height: at a narrow width
    // "137 credits" appearing is what pushes the row to two lines.
    measure();
    return true;
  }

  // HOW TALL THE STICKY BAR IS, published as --sc-site-bar-h for anything that has to sit below it
  // (today: the deck builder's summary strip, which is sticky at the same edge; stage 4's filter
  // bars next).
  //
  // MEASURED, NOT A CONSTANT, for the reason UIShell.measureCommandBar records about Zone 4: the
  // bar wraps to two rows somewhere near 340px and again when the balance arrives, and a hardcoded
  // height is wrong at exactly the widths that can least afford a hidden row. Cheap enough to call
  // on every render -- one getBoundingClientRect on an element that is always laid out.
  function measure() {
    const bar = document.querySelector('.site-bar');
    if (!bar) return 0;
    const h = Math.round(bar.getBoundingClientRect().height);
    if (h > 0) document.documentElement.style.setProperty('--sc-site-bar-h', h + 'px');
    return h;
  }

  // Two triggers, because those are the two things that resize it: the fonts settling after load,
  // and the viewport changing. There is deliberately no ResizeObserver here -- this bar holds a
  // fixed set of text nodes, unlike Zone 4 whose contents are rewritten per phase.
  if (typeof window !== 'undefined' && window.addEventListener) {
    window.addEventListener('load', measure);
    window.addEventListener('resize', measure);
  }

  return { render: render, measure: measure };
})();
